import React from "react";

import { FinancingPlan } from "../../../models/financing";
import { isoAPR } from "../../../models/nominals";
import { formatAPR, formatTermLength } from "../../../utils/format";

interface IProps {
    plan: {
        apr: FinancingPlan["apr"];
        term_months: FinancingPlan["term_months"];
    };
}

export const TermLengthAd = (props: IProps): React.JSX.Element | null => {
    if (parseInt(isoAPR.unwrap(props.plan.apr), 10) !== 0) {
        return null;
    }
    return (
        <div className="financing-form__feature">
            <div className="financing-form__feature--apr">
                {formatAPR(props.plan.apr)} APR
            </div>
            <div className="financing-form__feature--for">for</div>
            <div className="financing-form__feature--term">
                {formatTermLength(props.plan.term_months)} Months
            </div>
        </div>
    );
};
